<form [formGroup]="form">
  <!-- Active -->
  <div class="form-group">
    <label class="form-label" for="value">
      {{ options.label | portalTranslate }}
    </label>

    <ng-select
      id="value"
      [clearable]="false"
      [items]="options.choices"
      bindValue="value"
      formControlName="value"
      portalInputValidityState
    >
      <ng-template let-item="item" ng-label-tmp>
        {{ item.label | translate }}
      </ng-template>

      <ng-template let-item="item" ng-option-tmp>
        {{ item.label | translate }}
      </ng-template>
    </ng-select>

    <portal-form-validation-errors controlName="value"></portal-form-validation-errors>
  </div>
</form>
